module.exports = __webpack_public_path__ + "static/media/don-mind.e975648b.jpg";